module.exports = angular;


/*****************
 ** WEBPACK FOOTER
 ** external "angular"
 ** module id = 10
 ** module chunks = 2
 **/